__webpack_require__.p = "/sunk-cost-or-not/";